
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire893f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire893f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $72z4V = parcelRequire("72z4V");

var $l8biK = parcelRequire("l8biK");

var $le7Hi = parcelRequire("le7Hi");
/* eslint-disable */ // this is an auto generated file. This will be overwritten
const $2af249225bdc8257$export$9648cadeaf64ccee = /* GraphQL */ `
  mutation CreateVote(
    $input: CreateVoteInput!
    $condition: ModelVoteConditionInput
  ) {
    createVote(input: $input, condition: $condition) {
      id
      vote
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
const $2af249225bdc8257$export$8d49ed41db4e822e = /* GraphQL */ `
  mutation UpdateVote(
    $input: UpdateVoteInput!
    $condition: ModelVoteConditionInput
  ) {
    updateVote(input: $input, condition: $condition) {
      id
      vote
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
const $2af249225bdc8257$export$cd544f3ce43f52a7 = /* GraphQL */ `
  mutation DeleteVote(
    $input: DeleteVoteInput!
    $condition: ModelVoteConditionInput
  ) {
    deleteVote(input: $input, condition: $condition) {
      id
      vote
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;


(0, $72z4V.DefaultAmplify).configure((0, (/*@__PURE__*/$parcel$interopDefault($le7Hi))));
const $e73bf42412feb220$var$client = (0, $l8biK.generateClient)();
document.querySelectorAll(".vote").forEach((item)=>{
    console.log("add listener");
    item.addEventListener("click", $e73bf42412feb220$var$sendVote);
});
async function $e73bf42412feb220$var$sendVote(e) {
    var votedFor = e.target.dataset.ad;
    document.getElementById("options").classList.remove("novote");
    document.getElementById("options").classList.add("done");
    document.getElementById("instructions").innerText = "Processing your vote...";
    try {
        gtag("event", votedFor);
        const newVote = await $e73bf42412feb220$var$client.graphql({
            query: (0, $2af249225bdc8257$export$9648cadeaf64ccee),
            variables: {
                input: {
                    vote: votedFor
                }
            }
        });
        console.log(newVote);
        document.cookie = "vote25=" + votedFor + "; expires=Sun, 19 Feb 2025 23:59:59 GMT; Secure";
        document.getElementById(votedFor).classList.add("yes");
        document.getElementById("instructions").innerText = "Thanks for voting!";
    } catch (err) {
        console.error(err);
        document.cookie = "vote25=" + votedFor + "; expires=Sun, 19 Feb 2025 23:59:59 GMT; Secure";
        document.getElementById(votedFor).classList.add("yes");
        document.getElementById("instructions").innerText = "Thanks for voting!";
    /*
        setTimeout(() => {
        document.getElementById("options").classList.add("novote");
        document.getElementById("options").classList.remove("done");
        document.getElementById("instructions").innerText = "Vote for your favorite!";
        alert("Please try submitting your vote again");
        }, 320);
        */ }
}
function $e73bf42412feb220$var$init() {
    console.log("run init");
    if (document.cookie.split("; ").find((row)=>row.startsWith("vote25="))) {
        const cookieValue = document.cookie.split("; ").find((row)=>row.startsWith("vote25=")).split("=")[1];
        document.getElementById("options").classList.add("done");
        document.getElementById(cookieValue).classList.add("yes");
        document.getElementById("instructions").innerText = "Thanks for voting!";
    } else {
        document.getElementById("options").classList.add("novote");
        document.getElementById("instructions").innerText = "Vote for your favorite!";
    }
    document.getElementById("termsLink").onclick = function() {
        document.getElementById("terms").classList.toggle("show");
    };
//VOTE CLOSED
//  document.getElementById("options").classList.add("done");
//  document.getElementById("coke").classList.add("yes");
//  document.getElementById("instructions").innerText = "_____ is the 2025 Winner. Voting is closed. See you next year!";
}
window.onload = function() {
    $e73bf42412feb220$var$init();
};


//# sourceMappingURL=index.cf06841e.js.map
